import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
} from "@mui/material";
import { QUESTIONS } from "./lubrication-system-helper";
import { isSelected } from "./air-system-helper";

const CustomCheckBox = ({ label, checked, onChange, type }) => {
  if (type === "RADIO") {
    return (
      <FormControlLabel
        control={<Radio checked={checked} onChange={onChange} />}
        label={label}
      />
    );
  }

  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} />}
      label={label}
    />
  );
};

const LubricationSystem = ({ checklistDetails, setChecklistDetails }) => {
  const [details, setDetails] = useState(
    checklistDetails?.checkList?.lubeSystem || {}
  );

  const handleCheckboxChange = (question, option) => {
    const { apiKey } = question;
    const { apiOptionKey } = option;

    const updatedDetails = { ...details };

    if (question.type === "RADIO") {
      updatedDetails[apiKey] = option.label;
    } else {
      updatedDetails[apiOptionKey] = !details[apiOptionKey];
    }

    setDetails(updatedDetails);
  };

  const handleTextChange = (option, text) => {
    const { apiOptionKey } = option;
    setDetails({
      ...details,
      [apiOptionKey]: text,
    });
  };

  useEffect(() => {
    setChecklistDetails((prev) => ({
      ...prev,
      checkList: {
        ...prev?.checkList,
        lubeSystem: details,
      },
    }));
  }, [details]);

  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" gutterBottom>
        Lube System
      </Typography>

      {QUESTIONS?.map((question, index) => (
        <Box key={question.label} sx={{ mb: 3, px: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            {index + 1}. {question.label}
          </Typography>

          <Box display="flex" flexWrap="wrap" gap={2}>
            {question.type === "INPUT" && (
              <TextField
                fullWidth
                label={question.label}
                variant="outlined"
                value={details[question.apiKey] || ""}
                onChange={(e) =>
                  setDetails({
                    ...details,
                    [question.apiKey]: e.target.value,
                  })
                }
              />
            )}

            {question.options?.map((option) => {
              if (option.type === "INPUT") {
                return (
                  <TextField
                    key={option.label}
                    label={option.label}
                    variant="outlined"
                    value={details[option.apiOptionKey] || ""}
                    onChange={(e) => handleTextChange(option, e.target.value)}
                  />
                );
              } else {
                return (
                  <CustomCheckBox
                    key={option.label}
                    label={option.label}
                    type={question.type}
                    checked={isSelected(details, question, option)}
                    onChange={() => handleCheckboxChange(question, option)}
                  />
                );
              }
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default LubricationSystem;
